// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { parseAPIMenu } from './utils';
import { createAPINetworkInstance } from '../../../common/api';

// Types
import { ActionGetClientAPI, getMenuAPIError, getMenuAPISuccess, } from './actions';
import { Menu } from './types';

function* getMenu(action: ActionGetClientAPI) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, "/utils/platform_menu");
        const menuItems: Menu[] = parseAPIMenu(data);
        yield put(getMenuAPISuccess(menuItems));
    } catch (err) {
        yield put(getMenuAPIError(err));
    }
}

export default function* clientSagas() {
    yield takeLatest(ACTIONS.GET_MENU_API_REQUEST, getMenu);
}
